import { CSSProperties, ReactElement } from 'react'

type ColorValue = CSSProperties['backgroundColor']

interface ColorCircleProps {
    size?: number
    color: ColorValue
}

const ColorCircle = ({ size = 18, color }: ColorCircleProps): ReactElement => (
    <div
        style={{
            height: `${size}px`,
            width: `${size}px`,
            borderRadius: `${size}px`,
            backgroundColor: color,
        }}
    />
)

export default ColorCircle
